import { Link } from "react-router-dom";

const Reviews = () => {
	return (
		<section id="review-section" className="op-inScreen text-center my-8">
			<h1 className="text-[3.5rem] text-center font-cairo font-bold">تعاونت مع</h1>
			<div className="flex flex-col justify-around items-center my-8 lg:flex-row">
				<div className="flex flex-col text-center my-8">
					<img src="./assets/spirit-logo.png" alt="" />
					<h3 className="text-2xl">مركز سبيرت</h3>
				</div>
				<div className="flex flex-col text-center my-8">
					<img src="./assets/quranRadio-logo.jpeg" alt="" />
					<h3 className="text-2xl my-4">إذاعة القرءان الكريم</h3>
				</div>
				<div className="flex flex-col text-center content-between">
					<img className="" src="./assets/saraya-logo.png" alt="" />
					<h3 className="text-2xl">مركز السرايا</h3>
				</div>
				<div className="flex flex-col text-center my-8">
					<img src="./assets/spafford-logo.jpg" alt="" />
					<h3 className="text-2xl">مركز سبافورد</h3>
				</div>
				<div className="flex flex-col text-center my-8">
					<img src="./assets/oceanpalestine-logo.jpg" alt="" />
					<h3 className="text-2xl">محيط</h3>
				</div>
			</div>
			<Link className="" to="/contact">
				<button className=" bg-zinc-600 text-2xl text-white font-cairo font-bold rounded-md px-6 py-2">تواصل للعمل</button>
			</Link>
		</section>
	);
};

export default Reviews;
